/* eslint-disable no-console */
/* eslint-disable max-len */
import { TextField, Checkbox, Alert, Button } from '@mui/material';
import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../../libs/Context';
import { useSelector } from 'react-redux';
import { sendRequest } from '../../actions/license_subscription';
import { catchErr, formatBytes } from '../../../libs/HelperContent';
import { toast } from 'react-toastify';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';

const Card = (props) =>
{
	const { handleClose } = props;
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { language } = useContext(LanguageContext);
	const [ reqLoading, setReqLoading ] = useState<any>(false);
	const [ check, setCheck ] = useState({
		isEmployee : false,
		isRelation : false,
		isStorage  : false
	});
	const [ reqData, setReqData ] = useState<any>({
		emp     : '',
		relatn  : '',
		storage : ''
	});
	const licenseData = useSelector((state:any) => state.mylicense.license);

	const handleReq = async () =>
	{
		const data:any = {};

		if (reqData?.emp) { data.employeeInfo = Number(reqData?.emp); }
		if (reqData?.relatn) { data.relationInfo = Number(reqData?.relatn); }
		if (reqData?.storage) { data.mediaInfo = Number(reqData?.storage) * 1073741824; }

		const body = {
			requestedBy : userData?.companyId,
			empRole     : userData?.empRole,
			data

		};

		if (!reqLoading)
		{
			setReqLoading(true);
			try
			{
				const res = await sendRequest(body);

				if (res?.status)
				{
					toast.success(language?.licenseRequestSucessfull, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
				}
				setReqLoading(false);
			}
			catch (err)
			{
				catchErr(err);
				setReqLoading(false);
			}
		}
		handleClose();
	};
	const handleChange = (e, type) =>
	{
		const regex = /^[0-9\b]+$/;

		if (regex.test(e.target.value) || e.target.value === '')
		{
			const evnt = Number(e.target.value);
			const value = type === 'employe'
				? (evnt >= 0 && evnt <= 1000000)
				: type === 'relation'
					? (evnt >= 0 && evnt <= 10000)
					: (evnt >= 0 && evnt <= 1024);

			const id = e.target.id && e.target.name;

			if (value)setReqData((prev:any) => ({ ...prev, [id]: evnt }));
		}
	};

	const handleCheckboxChange = (checked:any) =>
	{
		setCheck((prev:any) => ({ ...prev, [checked]: !prev[checked] }));
	};
	const employeLeft = licenseData?.employeeInfo?.limit - licenseData?.employeeInfo?.used;
	const relationsLeft = licenseData?.relationInfo?.limit - licenseData?.relationInfo?.used;
	const storageLeft = (licenseData?.mediaInfo?.limit) - (licenseData?.mediaInfo?.used);

	return (
		<>
			{reqLoading && <Loading/>}
			<div className='flexCol'>
				<div className='flexCol pdngVXS' >
					<div className='flexCol whiteBg pdngXS'>
						<div className='flexRow alignCntr fontWeightMD'>
							<div >
								<Checkbox
									checked={check?.isEmployee}
									onChange={() => handleCheckboxChange('isEmployee')}
								/>
							</div>
							<span>{language?.employee} &nbsp;
								<span className={`${check?.isEmployee ? 'textDanger' : 'lightTxt'}`}>
									{`( ${licenseData?.employeeInfo?.used}/${licenseData?.employeeInfo?.limit} )`}
								</span>
							</span>
						</div>
						<div className='flexRow pdngXS'>
							{
								!check?.isEmployee
									? <span className='lightTxt pdngHXXS'>{`${language?.empLicenceSliderText1} ${licenseData?.employeeInfo?.limit} 
								${language?.empLicenceSliderText2} ${licenseData?.employeeInfo?.used} ${language?.empLicenceSliderText3} ${employeLeft} ${language?.empLicenceSliderText4},
						         `}</span>
									: <span>
										{employeLeft <= 0 && <Alert severity='error' className='requesterror'>{`${language?.youHaveReachedMaxLimit} ${licenseData?.employeeInfo?.limit} ${language?.andYouUsed}`}</Alert>}
									</span>

							}
						</div>
						{check?.isEmployee &&
						<div className='resColRowMobOnly pdngHXXS'>
							<div className='minWidthSliderText alignCntr'>
								<span className='fontWeightMD pdngXS'>{language?.currently} :</span>
								<span className='lightTxt pdngXXS'>{licenseData?.employeeInfo?.used} {language?.employees}</span></div>
							<div className='flexMinWidthRow alignCntr'>
								<span className='pdngXXS'>+</span>
								<div className='pdngXXS'>
									<TextField
										id='emp'
										name='emp'
										onChange={(e) => handleChange(e, 'employe')}
										value={reqData?.emp || ''}
										size='small'
										autoFocus
										fullWidth
										placeholder={language?.addEmp}
										inputProps={{ maxLength: 50 }}
										label={language?.addEmp}
										variant='outlined'
										type='text'
									/>
								</div>
							</div>
						</div>
						}
					</div>
				</div>
				<div className='flexCol pdngVXS' >
					<div className='flexCol whiteBg pdngXS'>
						<div className='flexRow alignCntr fontWeightMD'>
							<div >
								<Checkbox
									checked={check?.isRelation}
									onChange={() => handleCheckboxChange('isRelation')}
								/>
							</div>
							<span> {language?.relation }&nbsp;
								<span className={`${check?.isRelation ? 'textDanger' : 'lightTxt'}`}>
									{`( ${licenseData?.relationInfo?.used}/${licenseData?.relationInfo?.limit} )`}
								</span>
							</span>
						</div>
						<div className='flexRow pdngXS'>
							{!check?.isRelation
								? <span className='lightTxt pdngHXXS'>{`${language?.realtionLicenceSliderText1} ${licenseData?.relationInfo?.limit} ${language?.andYouUsed} ${licenseData?.relationInfo?.used}, ${language?.realtionLicenceSliderText2}
							${relationsLeft} ${language?.relation}.`}
								</span>
								: <span>{relationsLeft <= 0 && <Alert severity='error' className='requesterror'>{`${language?.youHaveReachedMaxLimit} ${licenseData?.relationInfo?.limit} ${language?.relation} ${language?.onThefreeplan}`}</Alert>}
								</span>
							}
						</div>
						{check?.isRelation &&
						<div className='resColRowMobOnly pdngHXXS'>
							<div className='minWidthSliderText alignCntr'>
								<span className='fontWeightMD pdngXS'>{language?.currently} :</span>
								<span className='lightTxt pdngXXS'>{licenseData?.relationInfo?.used} {language?.relation}</span></div>
							<div className='flexMinWidthRow alignCntr'>
								<span className='pdngXXS'>+</span>
								<div className='pdngXXS'>
									<TextField
										id='relatn'
										name='relatn'
										onChange={(e) => handleChange(e, 'relation')}
										value={reqData?.relatn || ''}
										size='small'
										autoFocus
										fullWidth
										placeholder={language?.addrel}
										inputProps={{ maxLength: 50 }}
										label={language?.addrel}
										variant='outlined'
										type='text'
									/>
								</div>
							</div>
						</div>
						}
					</div>
				</div>
				<div className='flexCol pdngVXS' >
					<div className='flexCol whiteBg pdngXS'>
						<div className='flexRow alignCntr fontWeightMD'>
							<div >
								<Checkbox
									checked={check?.isStorage}
									onChange={() => handleCheckboxChange('isStorage')}
								/>
							</div>
							<span> {language?.storage} &nbsp;
								<span className={`${check?.isStorage ? 'textDanger' : 'lightTxt'}`}>
									( {formatBytes(licenseData?.mediaInfo?.used)} / { formatBytes(licenseData?.mediaInfo?.limit)} )
								</span></span>
						</div>
						<div className='flexRow pdngXS'>

							{!check?.isStorage
								? <span className='lightTxt pdngHXXS'>
									{`${language?.mediaLicenceSliderText1} ${formatBytes(licenseData?.mediaInfo?.used)},
									${language?.mediaLicenceSliderText2}
									${formatBytes(storageLeft)} ${language?.mediaLicenceSliderText3}`}
								</span>
								: <span>{storageLeft <= 0 && <Alert severity='error' className='requesterror'>{`${language?.youHaveReachedMaxLimit} ${formatBytes(licenseData?.mediaInfo?.used)} ${language?.onThefreeplan}`}</Alert>}
								</span>
							}
						</div>
						{check?.isStorage &&
						<div className='resColRowMobOnly pdngHXXS'>
							<div className='minWidthSliderText alignCntr'>
								<span className='fontWeightMD pdngXS'>{language?.currently} :</span>
								<span className='lightTxt pdngXXS'>{formatBytes(licenseData?.mediaInfo?.used)} {language?.storage}</span></div>
							<div className='flexMinWidthRow alignCntr'>
								<span className='pdngXXS'>+</span>
								<div className='pdngXXS'>
									<TextField
										id='storage'
										name='storage'
										onChange={(e) => handleChange(e, 'storage')}
										value={reqData?.storage || ''}
										size='small'
										autoFocus
										fullWidth
										placeholder={language?.addStorageInGB}
										inputProps={{ maxLength: 50 }}
										label={language?.addStorageInGB}
										variant='outlined'
										type='text'
									/>
								</div>
							</div>
						</div>
						}
					</div>
				</div>
				<div className='flexRow pdngMD justifyEnd alignCntr'>
					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }} onClick={handleClose}>
						<Button disableElevation disableRipple variant='outlined'>
							{language?.cancel}
						</Button></button>
					<span className='pdngHMD'>
						<Button
							disableElevation
							tabIndex={0}
							onKeyUp={(e) => { e.key === 'Enter' && handleReq(); }}
							disabled={!reqData.emp && !reqData.relatn && !reqData.storage}
							disableRipple variant='contained'
							className='whiteTxt'
							onClick={handleReq}
						>
							{language?.sendreq}
						</Button>
					</span>
				</div>
			</div>
		</>
	);
};

export default Card;